/** Simple rolling FPS meter from frame deltas (ms). */
export class FpsMeter {
  private samples: number[] = [];
  private readonly windowSize: number;
  private lastMs: number | null = null;
  private _fps = 0;

  constructor(windowSize = 30) {
    this.windowSize = Math.max(5, windowSize);
  }

  /** Call once per animation frame with performance.now() (or equivalent). */
  tick(nowMs: number): number {
    if (this.lastMs != null) {
      const dt = nowMs - this.lastMs;
      if (dt > 0 && dt < 1000) {
        this.samples.push(dt);
        if (this.samples.length > this.windowSize) {
          this.samples.shift();
        }
        const avg =
          this.samples.reduce((a, b) => a + b, 0) / this.samples.length;
        this._fps = 1000 / avg;
      }
    }
    this.lastMs = nowMs;
    return this._fps;
  }

  get fps(): number {
    return this._fps;
  }

  get display(): string {
    if (this.samples.length < 3) return "--";
    return String(Math.round(this._fps));
  }
}
